(function(){
  var root=document.querySelector(".__pf_STNno-es");
  var assets=document.querySelector("[data-fire-assets]");
  if(!root||!assets)return;

  var heroAsset=assets.getAttribute("data-fire-hero");
  var homeAsset=assets.getAttribute("data-fire-home");
  var scienceAsset=assets.getAttribute("data-fire-science");
  var mitochondriaAsset=assets.getAttribute("data-fire-mitochondria");
  var localizedFatAsset=assets.getAttribute("data-fire-localized-fat");
  var irradianceAsset=assets.getAttribute("data-fire-irradiance");
  var manualAsset=assets.getAttribute("data-fire-manual");
  var storyAsset=assets.getAttribute("data-fire-story");
  if(scienceAsset)root.style.setProperty("--fire-science-image",'url("'+scienceAsset+'")');
  if(homeAsset)root.style.setProperty("--fire-home-image",'url("'+homeAsset+'")');

  /* Ordine editoriale: prima spiega il meccanismo e subito dopo presenta la
     lampada. La modifica sposta soltanto i due blocchi PageFly interessati. */
  var resultsMechanismSection=root.querySelector('[data-section-id="pf-2ed9"]');
  var spartanFireLampSection=root.querySelector('[data-section-id="pf-4a3c"]');
  if(resultsMechanismSection&&spartanFireLampSection&&resultsMechanismSection.parentNode===spartanFireLampSection.parentNode){
    spartanFireLampSection.parentNode.insertBefore(resultsMechanismSection,spartanFireLampSection);
  }

  /* Meccanismo cellulare: sostituisce il vecchio visual tecnico PageFly con
     un diagramma essenziale luce -> mitocondrio -> energia, senza alterare il
     copy scientifico della sezione. */
  var mitochondriaImage=root.querySelector(".pf-153_");
  if(mitochondriaImage&&mitochondriaAsset){
    mitochondriaImage.src=mitochondriaAsset;
    mitochondriaImage.srcset="";
    mitochondriaImage.width=1000;
    mitochondriaImage.height=1000;
    mitochondriaImage.alt="La luce rossa e vicino infrarosso raggiunge il mitocondrio, che contribuisce alla produzione di energia cellulare";
    mitochondriaImage.loading="lazy";
    mitochondriaImage.decoding="async";
  }

  /* Studio sul dimagrimento localizzato: sostituisce il vecchio visual stock
     con una scena domestica sobria che mostra la corretta relazione tra il
     pannello e l'area illuminata, senza alterare copy o citazioni. */
  var localizedFatImage=root.querySelector(".pf-204_");
  if(localizedFatImage&&localizedFatAsset){
    localizedFatImage.src=localizedFatAsset;
    localizedFatImage.srcset="";
    localizedFatImage.width=1000;
    localizedFatImage.height=1250;
    localizedFatImage.alt="Spartan Fire orientata verso addome e fianchi durante una sessione domestica";
    localizedFatImage.loading="lazy";
    localizedFatImage.decoding="async";
    localizedFatImage.dataset.fireLocalizedFatImage="true";
  }

  /* Scientific story: the former red follow-up band now completes the white
     editorial section above it. "Ma, secondo gli scienziati," belongs to the
     preceding paragraph instead of behaving like a separate headline. */
  var cellularEnergyParagraph=root.querySelector(".pf-150_");
  var scientistsLead=root.querySelector(".pf-155_");
  if(cellularEnergyParagraph&&scientistsLead&&cellularEnergyParagraph.dataset.fireScientistsLead!=="true"){
    var scientistsContinuation=document.createElement("span");
    scientistsContinuation.className="fire-scientists-continuation";
    scientistsContinuation.textContent="Ma, secondo gli scienziati,";
    cellularEnergyParagraph.appendChild(document.createElement("br"));
    cellularEnergyParagraph.appendChild(document.createElement("br"));
    cellularEnergyParagraph.appendChild(scientistsContinuation);
    cellularEnergyParagraph.dataset.fireScientistsLead="true";
    scientistsLead.setAttribute("aria-hidden","true");
  }

  var lightDeficiencyClaim=root.querySelector(".pf-157_");
  if(lightDeficiencyClaim){
    lightDeficiencyClaim.innerHTML='il 90% delle persone è “carente di luce”...<sup>[23]</sup>';
  }

  /* Testimonianza video: mantiene la struttura della bozza ma sincronizza il
     player Vturb pubblicato sul tema Live, sostituendo il vecchio Vimeo. */
  var testimonialVideo=root.querySelector('[data-section-id="pf-a875"] [data-pf-type="Vimeo3"]');
  var testimonialPlayerId="vid-6a86c0468f975dcf3e076157";
  var testimonialPlayerSrc="https://scripts.converteai.net/cf27970a-f287-4eb7-8106-bf30c73ec13c/players/6a86c0468f975dcf3e076157/v4/player.js";
  if(testimonialVideo&&!root.querySelector("#"+testimonialPlayerId)){
    testimonialVideo.setAttribute("data-pf-type","Custom.HTML");
    testimonialVideo.classList.add("fire-testimonial-player");
    testimonialVideo.style.width="100%";
    testimonialVideo.textContent="";

    var smartPlayer=document.createElement("vturb-smartplayer");
    smartPlayer.id=testimonialPlayerId;
    smartPlayer.style.cssText="display:block;margin:0 auto;width:100%";
    smartPlayer.innerHTML='<div class="vturb-player-placeholder" style="position:relative;width:100%;padding:56.25% 0 0;z-index:0;background-color:#000"></div>';
    testimonialVideo.appendChild(smartPlayer);

    if(!document.querySelector('script[src="'+testimonialPlayerSrc+'"]')){
      var testimonialPlayerScript=document.createElement("script");
      testimonialPlayerScript.src=testimonialPlayerSrc;
      testimonialPlayerScript.async=true;
      testimonialPlayerScript.dataset.fireTestimonialPlayer="true";
      document.head.appendChild(testimonialPlayerScript);
    }
  }

  /* Fallback senza carosello: la prima slide PageFly mostra l'hero premium. */
  var mainImage=root.querySelector(".pf-14_ .pf-slide-main-media:first-child img");
  if(mainImage&&heroAsset){
    mainImage.src=heroAsset;
    mainImage.srcset="";
    mainImage.width=1254;
    mainImage.height=1254;
    mainImage.alt="Spartan Fire — lampada per fotobiomodulazione";
    mainImage.setAttribute("fetchpriority","high");
    mainImage.removeAttribute("loading");
  }

  /* Diagramma nitido del confronto di irraggiamento nella sezione unicità. */
  var irradianceImage=root.querySelector(".pf-275_");
  if(irradianceImage&&irradianceAsset){
    irradianceImage.src=irradianceAsset;
    irradianceImage.srcset="";
    irradianceImage.width=1254;
    irradianceImage.height=1254;
    irradianceImage.alt="Confronto di potenza e profondità: Spartan Fire raggiunge i muscoli, altri dispositivi il derma";
  }

  /* Manuale incluso: sostituisce la vecchia copertina promozionale con un
     mockup editoriale premium senza alterare la struttura PageFly. */
  var manualImage=root.querySelector(".pf-476_");
  if(manualImage&&manualAsset){
    manualImage.src=manualAsset;
    manualImage.srcset="";
    manualImage.width=800;
    manualImage.height=1200;
    manualImage.alt="I segreti della luce rossa — manuale pratico di fotobiomodulazione di Filippo Pagani";
    manualImage.loading="lazy";
    manualImage.decoding="async";
  }

  /* PageFly currently nests three review rows inside a fourth row. Flatten the
     real 13 review cards so they cannot overlap, while keeping bibliography and
     the legal disclaimer directly below the grid. */
  var testimonialSection=root.querySelector(".pf-569_");
  var testimonialSectionInner=testimonialSection&&testimonialSection.querySelector(":scope > .pf-flex-section");
  if(testimonialSectionInner&&testimonialSectionInner.dataset.fireTestimonialsReady!=="true"){
    var testimonialCards=Array.prototype.filter.call(testimonialSection.querySelectorAll("div"),function(card){
      var directParagraphs=Array.prototype.filter.call(card.children,function(child){return child.tagName==="P";});
      var stars=card.firstElementChild&&card.firstElementChild.querySelectorAll(":scope > svg");
      return directParagraphs.length===3&&stars&&stars.length===5;
    });
    if(testimonialCards.length){
      var testimonialGrid=document.createElement("div");
      testimonialGrid.className="fire-testimonial-grid";
      testimonialGrid.setAttribute("role","list");
      testimonialGrid.setAttribute("aria-label","Testimonianze Spartan Fire");

      testimonialCards.forEach(function(card){
        card.classList.add("fire-testimonial-card");
        card.setAttribute("role","listitem");
        testimonialGrid.appendChild(card);
      });

      var testimonialIntro=testimonialSectionInner.querySelector(":scope > .pf-572_");
      var testimonialHeadline=testimonialSectionInner.querySelector(":scope > .pf-570_");
      var testimonialAnchor=testimonialIntro||testimonialHeadline;
      if(testimonialAnchor)testimonialAnchor.insertAdjacentElement("afterend",testimonialGrid);
      else testimonialSectionInner.prepend(testimonialGrid);

      var bibliography=testimonialSection.querySelector(".pf-761_");
      var testimonialDisclaimer=testimonialSection.querySelector(".pf-770_");
      if(bibliography)testimonialSectionInner.appendChild(bibliography);
      if(testimonialDisclaimer)testimonialSectionInner.appendChild(testimonialDisclaimer);

      [".pf-574_",".pf-614_"].forEach(function(selector){
        var obsoleteGroup=testimonialSectionInner.querySelector(":scope > "+selector);
        if(obsoleteGroup)obsoleteGroup.remove();
      });
      testimonialSectionInner.dataset.fireTestimonialsReady="true";
    }
  }

  /* Above the fold: replace the old two-line guarantee box with the three
     existing PageFly assurance badges and a compact expandable explanation. */
  var assuranceBox=root.querySelector(".pf-48_");
  if(assuranceBox&&assuranceBox.dataset.fireAssurancesReady!=="true"){
    var assuranceItems=[
      {icon:".pf-69_",label:"Spedizione Gratuita in Italia"},
      {icon:".pf-74_",label:"Garanzia di Buon Funzionamento"},
      {icon:".pf-79_",label:"Garanzia di Soddisfazione Totale"}
    ];
    var assuranceBadges=document.createElement("div");
    assuranceBadges.className="fire-assurance-badges";

    assuranceItems.forEach(function(item){
      var badge=document.createElement("div");
      badge.className="fire-assurance-badge";
      var sourceIcon=root.querySelector(item.icon);
      if(sourceIcon){
        var icon=sourceIcon.cloneNode(true);
        icon.setAttribute("class","fire-assurance-icon");
        icon.setAttribute("aria-hidden","true");
        icon.removeAttribute("data-pf-type");
        icon.removeAttribute("style");
        badge.appendChild(icon);
      }
      var label=document.createElement("span");
      label.textContent=item.label;
      badge.appendChild(label);
      assuranceBadges.appendChild(badge);
    });

    var guaranteeDetails=document.createElement("details");
    guaranteeDetails.className="fire-guarantee-details";
    var guaranteeSummary=document.createElement("summary");
    var guaranteeSummaryLabel=document.createElement("span");
    guaranteeSummaryLabel.textContent="Dettagli sulle garanzie";
    guaranteeSummary.appendChild(guaranteeSummaryLabel);
    guaranteeSummary.insertAdjacentHTML("beforeend",'<svg class="fire-guarantee-chevron" aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M7 9.5l5 5 5-5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>');
    guaranteeDetails.appendChild(guaranteeSummary);

    var guaranteeCopy=document.createElement("div");
    guaranteeCopy.className="fire-guarantee-copy";
    var satisfactionCopy=document.createElement("p");
    satisfactionCopy.textContent="Hai 180 giorni per decidere se Spartan Fire fa per te. Se non ne sei elettrizzato, rinviacele indietro e ti rimborseremo l'intero importo.";
    var operationCopy=document.createElement("p");
    operationCopy.textContent="La Spartan Fire è garantita funzionare per 3 anni o te le cambieremo gratuitamente.";
    guaranteeCopy.appendChild(satisfactionCopy);
    guaranteeCopy.appendChild(operationCopy);
    guaranteeDetails.appendChild(guaranteeCopy);

    assuranceBox.textContent="";
    assuranceBox.classList.add("fire-purchase-assurances");
    assuranceBox.appendChild(assuranceBadges);
    assuranceBox.appendChild(guaranteeDetails);
    assuranceBox.dataset.fireAssurancesReady="true";
  }

  /* Above the fold: six concise, benefit-led claims with distinct icons and
     clickable references to the bibliography already used on the page. */
  var heroBenefitList=root.querySelector(".pf-27_");
  if(heroBenefitList&&heroBenefitList.dataset.fireBenefitsReady!=="true"){
    var heroBenefits=[
      {
        title:"Più energia, dal profondo",
        copy:"stimola i mitocondri a produrre più ATP, il carburante di ogni cellula",
        icon:'<path d="M13 2 4.5 13h6L9 22l8.5-12h-6L13 2Z"/>',
        refs:[
          {number:22,url:"https://pubmed.ncbi.nlm.nih.gov/29164625/"}
        ]
      },
      {
        title:"Recupero muscolare più rapido",
        copy:"la luce arriva fino al muscolo, non si ferma alla pelle",
        icon:'<path d="M20 7v5h-5"/><path d="M18.4 16.5A8 8 0 1 1 20 12"/><path d="M9 13.5 11.2 16 15 10"/>',
        refs:[
          {number:6,url:"https://pubmed.ncbi.nlm.nih.gov/16875447/"},
          {number:19,url:"https://pubmed.ncbi.nlm.nih.gov/27088469/"},
          {number:21,url:"https://pubmed.ncbi.nlm.nih.gov/25417170/"},
          {number:29,url:"https://pubmed.ncbi.nlm.nih.gov/40995827/"}
        ]
      },
      {
        title:"Muscoli e articolazioni più liberi",
        copy:"dopo l'allenamento e dopo i 40",
        icon:'<circle cx="7" cy="7" r="2.5"/><circle cx="17" cy="17" r="2.5"/><path d="m8.8 8.8 6.4 6.4M4 13h4l3 3 2-5h7"/>',
        refs:[
          {number:3,url:"https://pubmed.ncbi.nlm.nih.gov/16371497/"},
          {number:4,url:"https://pubmed.ncbi.nlm.nih.gov/16503786/"},
          {number:6,url:"https://pubmed.ncbi.nlm.nih.gov/16875447/"},
          {number:34,url:"https://pubmed.ncbi.nlm.nih.gov/40770824/"}
        ]
      },
      {
        title:"Sonno più profondo",
        copy:"usata la sera rilassa senza sopprimere la melatonina, al contrario degli schermi",
        icon:'<path d="M20.5 15.2A8.6 8.6 0 0 1 8.8 3.5 8.7 8.7 0 1 0 20.5 15.2Z"/><path d="M16.5 4.5v3M15 6h3"/>',
        refs:[
          {number:12,url:"https://pubmed.ncbi.nlm.nih.gov/23182016/"}
        ]
      },
      {
        title:"Pelle più tonica e giovane",
        copy:"più collagene, meno rughe e smagliature",
        icon:'<path d="M12 3c-3.8 0-6 2.8-6 6.7C6 15.3 8.7 21 12 21s6-5.7 6-11.3C18 5.8 15.8 3 12 3Z"/><path d="M9.2 10.5h.1M14.7 10.5h.1M9.5 15c1.6 1.2 3.4 1.2 5 0"/>',
        refs:[
          {number:1,url:"https://pubmed.ncbi.nlm.nih.gov/24049929/"},
          {number:26,url:"https://pmc.ncbi.nlm.nih.gov/articles/PMC3926176/"}
        ]
      },
      {
        title:"5 lunghezze d'onda in un'unica lampada",
        copy:"630 e 660 nm nel rosso per la pelle, 810, 830 e 850 nm nel vicino infrarosso per muscoli e tessuti profondi",
        icon:'<path d="M5 9.5a10 10 0 0 1 14 0M8 12.5a5.7 5.7 0 0 1 8 0M10.8 15.4a1.8 1.8 0 0 1 2.4 0"/><circle cx="12" cy="19" r="1"/>',
        refs:[
          {number:2,url:"https://pubmed.ncbi.nlm.nih.gov/41789284/"},
          {number:22,url:"https://pubmed.ncbi.nlm.nih.gov/29164625/"}
        ]
      }
    ];

    heroBenefitList.textContent="";
    heroBenefits.forEach(function(benefit){
      var item=document.createElement("li");
      item.className="fire-hero-benefit";

      var icon=document.createElementNS("http://www.w3.org/2000/svg","svg");
      icon.setAttribute("class","fire-hero-benefit-icon");
      icon.setAttribute("viewBox","0 0 24 24");
      icon.setAttribute("fill","none");
      icon.setAttribute("stroke","currentColor");
      icon.setAttribute("stroke-width","1.7");
      icon.setAttribute("stroke-linecap","round");
      icon.setAttribute("stroke-linejoin","round");
      icon.setAttribute("aria-hidden","true");
      icon.innerHTML=benefit.icon;

      var content=document.createElement("span");
      content.className="fire-hero-benefit-copy";
      var title=document.createElement("strong");
      title.textContent=benefit.title;
      var separator=document.createTextNode(" — ");
      var copy=document.createElement("span");
      copy.textContent=benefit.copy;
      content.appendChild(title);
      content.appendChild(separator);
      content.appendChild(copy);

      var citations=document.createElement("sup");
      citations.className="fire-hero-benefit-citations";
      citations.appendChild(document.createTextNode("["));
      benefit.refs.forEach(function(ref,index){
        if(index)citations.appendChild(document.createTextNode(","));
        var link=document.createElement("a");
        link.href=ref.url;
        link.target="_blank";
        link.rel="noopener noreferrer";
        link.textContent=ref.number;
        link.setAttribute("aria-label","Apri il riferimento bibliografico "+ref.number);
        citations.appendChild(link);
      });
      citations.appendChild(document.createTextNode("]"));
      content.appendChild(citations);

      item.appendChild(icon);
      item.appendChild(content);
      heroBenefitList.appendChild(item);
    });
    heroBenefitList.dataset.fireBenefitsReady="true";
  }

  /* Benefits section: keep one uniform headline and move the three existing
     research blocks here. Moving the original nodes preserves their copy,
     imagery and citations while removing the duplicated lower section. */
  var benefitsSection=root.querySelector(".pf-83_");
  var benefitsTitle=benefitsSection&&benefitsSection.querySelector(".pf-84_");
  var benefitsTitleContinuation=benefitsSection&&benefitsSection.querySelector(".pf-86_");
  var benefitsIconGrid=benefitsSection&&benefitsSection.querySelector(".pf-88_");
  var studySourceSection=root.querySelector(".pf-192_");
  var studyGroup=studySourceSection&&studySourceSection.querySelector(".pf-194_");

  if(benefitsSection&&benefitsTitle&&benefitsIconGrid&&studyGroup&&benefitsSection.dataset.fireStudiesReady!=="true"){
    benefitsTitle.textContent="I benefici della fotobiomodulazione su corpo e mente";
    benefitsTitle.classList.add("fire-benefits-title");
    if(benefitsTitleContinuation)benefitsTitleContinuation.remove();

    var studyIntro=studyGroup.querySelector(".pf-195_");
    if(studyIntro)studyIntro.remove();
    studyGroup.classList.add("fire-benefit-studies");
    [".pf-197_",".pf-205_",".pf-213_"].forEach(function(selector){
      var study=studyGroup.querySelector(selector);
      if(study)study.classList.add("fire-benefit-study");
    });
    [".pf-200_",".pf-208_",".pf-216_"].forEach(function(selector){
      var studyBody=studyGroup.querySelector(selector);
      if(studyBody)studyBody.classList.add("fire-benefit-study-body");
    });

    benefitsIconGrid.replaceWith(studyGroup);
    studySourceSection.remove();
    benefitsSection.dataset.fireStudiesReady="true";
  }

  /* Product story: reuse the dormant PageFly media column and show the
     five-wavelength visual beside the copy. */
  var storyImage=root.querySelector(".pf-224_");
  var storyGallery=(assets.getAttribute("data-fire-gallery")||"").split("|").filter(Boolean);
  var storyImageAsset=storyAsset||storyGallery.find(function(src){return src.indexOf("spartan-fire-gallery-02-cinque-lunghezze")>-1;})||storyGallery[1];
  if(storyImage&&storyImageAsset){
    storyImage.src=storyImageAsset;
    storyImage.srcset="";
    storyImage.width=1254;
    storyImage.height=1254;
    storyImage.alt="Spartan Fire con cinque lunghezze d'onda: 630, 660, 810, 830 e 850 nanometri";
    storyImage.loading="lazy";
    storyImage.dataset.fireStoryImage="true";
  }

  /* Carosello galleria.
     La lista arriva dall'hook data-fire-gallery; in sua assenza viene derivata
     dagli asset premium già esposti, così il carosello regge anche su un tema
     la cui sezione PageFly non è ancora aggiornata. */
  var mediaCard=root.querySelector(".pf-14_");
  var slider=root.querySelector(".pf-14_ .pf-media-slider");
  var gallery=(assets.getAttribute("data-fire-gallery")||"").split("|").filter(Boolean);
  var galleryAlts=(assets.getAttribute("data-fire-gallery-alts")||"").split("|");
  if(gallery.length<2&&heroAsset&&heroAsset.indexOf("/")>-1){
    var assetBase=heroAsset.slice(0,heroAsset.lastIndexOf("/")+1);
    gallery=[heroAsset,assetBase+"fire-premium-hero.jpg",homeAsset||assetBase+"fire-premium-home-v2.jpg",assetBase+"fire-premium-recovery.jpg",scienceAsset||assetBase+"fire-premium-science.jpg"].filter(Boolean);
  }
  if(mediaCard&&slider&&gallery.length>1&&!mediaCard.dataset.fireCarouselReady){
    mediaCard.dataset.fireCarouselReady="true";

    var carousel=document.createElement("div");
    carousel.className="fire-carousel";
    carousel.setAttribute("role","region");
    carousel.setAttribute("aria-label","Galleria immagini Spartan Fire");

    var track=document.createElement("div");
    track.className="fire-carousel-track";

    gallery.forEach(function(src,i){
      var slide=document.createElement("figure");
      slide.className="fire-carousel-slide";
      var img=document.createElement("img");
      img.src=src;
      img.width=1254;
      img.height=1254;
      img.alt=galleryAlts[i]||"Spartan Fire — immagine "+(i+1)+" di "+gallery.length;
      if(i===0){img.setAttribute("fetchpriority","high");}
      else{img.loading="lazy";}
      slide.appendChild(img);
      track.appendChild(slide);
    });
    carousel.appendChild(track);

    var current=0;
    var dots=[];
    var thumbs=[];

    function goTo(index){
      current=(index+gallery.length)%gallery.length;
      track.style.transform="translateX(-"+(current*100)+"%)";
      [current,current+1,current-1].forEach(function(n){
        var img=track.children[(n+gallery.length)%gallery.length];
        img=img&&img.querySelector("img");
        if(img&&img.loading==="lazy")img.loading="eager";
      });
      dots.forEach(function(dot,i){
        dot.classList.toggle("is-active",i===current);
        dot.setAttribute("aria-current",i===current?"true":"false");
      });
      thumbs.forEach(function(thumb,i){
        thumb.classList.toggle("is-active",i===current);
        thumb.setAttribute("aria-current",i===current?"true":"false");
      });
    }

    function makeArrow(dir){
      var btn=document.createElement("button");
      btn.type="button";
      btn.className="fire-carousel-arrow fire-carousel-arrow--"+(dir<0?"prev":"next");
      btn.setAttribute("aria-label",dir<0?"Immagine precedente":"Immagine successiva");
      btn.innerHTML=dir<0
        ?'<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        :'<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.addEventListener("click",function(){goTo(current+dir);});
      return btn;
    }
    carousel.appendChild(makeArrow(-1));
    carousel.appendChild(makeArrow(1));

    var dotsWrap=document.createElement("div");
    dotsWrap.className="fire-carousel-dots";
    gallery.forEach(function(_,i){
      var dot=document.createElement("button");
      dot.type="button";
      dot.className="fire-carousel-dot";
      dot.setAttribute("aria-label","Vai all'immagine "+(i+1));
      dot.addEventListener("click",function(){goTo(i);});
      dots.push(dot);
      dotsWrap.appendChild(dot);
    });
    carousel.appendChild(dotsWrap);

    /* Swipe touch/mouse. */
    var startX=null;
    carousel.addEventListener("pointerdown",function(e){startX=e.clientX;});
    carousel.addEventListener("pointerup",function(e){
      if(startX===null)return;
      var delta=e.clientX-startX;
      startX=null;
      if(delta>44)goTo(current-1);
      else if(delta<-44)goTo(current+1);
    });
    carousel.addEventListener("keydown",function(e){
      if(e.key==="ArrowLeft"){e.preventDefault();goTo(current-1);}
      if(e.key==="ArrowRight"){e.preventDefault();goTo(current+1);}
    });

    slider.appendChild(carousel);

    var thumbsWrap=document.createElement("div");
    thumbsWrap.className="fire-carousel-thumbs";
    gallery.forEach(function(src,i){
      var thumb=document.createElement("button");
      thumb.type="button";
      thumb.className="fire-carousel-thumb";
      thumb.setAttribute("aria-label","Mostra immagine "+(i+1));
      var img=document.createElement("img");
      img.src=src;
      img.width=320;
      img.height=320;
      img.alt="";
      img.loading="lazy";
      thumb.appendChild(img);
      thumb.addEventListener("click",function(){goTo(i);});
      thumbs.push(thumb);
      thumbsWrap.appendChild(thumb);
    });
    mediaCard.insertAdjacentElement("afterend",thumbsWrap);

    goTo(0);
  }

  root.querySelectorAll(".pf-253_ li").forEach(function(item){
    if(item.dataset.fireWaveReady==="true")return;
    var raw=Array.prototype.filter.call(item.childNodes,function(node){return node.nodeType===3;})
      .map(function(node){return node.textContent;}).join(" ").trim();
    var match=raw.match(/^(\d+)(\s*nm)?\s+(.*)$/i);
    if(!match)return;

    var metric=document.createElement("span");
    metric.className="fire-wave-metric";
    var value=document.createElement("strong");
    value.textContent=match[1];
    metric.appendChild(value);
    if(match[2]){
      var unit=document.createElement("small");
      unit.textContent=match[2].trim();
      metric.appendChild(unit);
    }

    var copy=document.createElement("span");
    copy.className="fire-wave-copy";
    copy.textContent=match[3];
    item.textContent="";
    item.appendChild(metric);
    item.appendChild(copy);
    item.dataset.fireWaveReady="true";
  });
})();
